import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isFuneralHome } from '~/utils/helpers';
import { Wrapper, Header, Message } from './customMessage.styles';
const CustomMessage = ({ txtMessage, type }) => {
    const numberOfLineBreaks = (txtMessage.match(/\n/g) || []).length;
    return (_jsxs(Wrapper, { children: [_jsx(Header, { children: isFuneralHome(type) ? 'Message from the Funeral Home' : 'Message from the Host' }), _jsx(Message, { className: "eventCustomMsg wrapNlToBr", multipleLine: numberOfLineBreaks > 1, children: txtMessage })] }));
};
export default CustomMessage;
